import React, { useState } from 'react';
import { MoreHorizontal, Loader2, Play, Settings, History, Stethoscope, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';

export interface RowActionsMenuProps {
  onRunNow: () => void;
  onConfigure: () => void;
  onViewHistory: () => void;
  onTestConnection: () => void;
  onDelete: () => void;
  isLoading: boolean;
}

export const RowActionsMenu: React.FC<RowActionsMenuProps> = ({
  onRunNow,
  onConfigure,
  onViewHistory,
  onTestConnection,
  onDelete,
  isLoading,
}) => {
  const [open, setOpen] = useState(false);

  const item = (label: string, Icon: React.ComponentType<{ className?: string }>, fn: () => void, danger = false) => (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        setOpen(false);
        fn();
      }}
      className={`w-full flex items-center gap-2 px-3 py-1.5 text-sm hover:bg-muted text-left ${
        danger ? 'text-destructive' : ''
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </button>
  );

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          aria-label="Actions"
          disabled={isLoading}
          onClick={(e) => e.stopPropagation()}
        >
          {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : <MoreHorizontal className="h-4 w-4" />}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="p-1 w-48">
        {item('Run Now', Play, onRunNow)}
        {item('Configure', Settings, onConfigure)}
        {item('View History', History, onViewHistory)}
        {item('Test Connection', Stethoscope, onTestConnection)}
        {item('Delete', Trash2, onDelete, true)}
      </PopoverContent>
    </Popover>
  );
};
